export default "<span class=\"success\">\r\n  {{data}}\r\n</span>\r\n\r\n"